import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import { isTemporaryNumber, NumberKind, TEMPORARY_HINT, TEMPORARY_LABEL } from './temporaryNumber';

/** A number with a "Temporary" chip while it is a temporary reference, and
 * (optionally) the temporary reference it replaced. */
export const NumberLabel = ({
  value,
  kind,
  previous,
  variant = 'body2',
}: {
  value: string | null | undefined;
  kind: NumberKind;
  previous?: string | null;
  variant?: 'body2' | 'caption' | 'inherit';
}) => {
  if (!value) return <>—</>;
  const temporary = isTemporaryNumber(value);
  return (
    <Stack
      component="span"
      direction="row"
      spacing={0.75}
      alignItems="center"
      sx={{ display: 'inline-flex', flexWrap: 'wrap' }}
      data-testid={`${kind}-number`}
    >
      <Typography component="span" variant={variant}>
        {value}
      </Typography>
      {temporary && (
        <Tooltip title={`${TEMPORARY_LABEL[kind]}. ${TEMPORARY_HINT[kind]}`}>
          <Chip
            component="span"
            size="small"
            color="warning"
            variant="outlined"
            label="Temporary"
            aria-label={TEMPORARY_LABEL[kind]}
            sx={{ height: 20, fontSize: 11 }}
          />
        </Tooltip>
      )}
      {!temporary && previous && previous !== value && (
        <Typography component="span" variant="caption" color="text.secondary">
          (was {previous})
        </Typography>
      )}
    </Stack>
  );
};
